// extracted by mini-css-extract-plugin
module.exports = {"app-code-dynamic":"Dynamic_app-code-dynamic__179Yo","appCodeDynamic":"Dynamic_app-code-dynamic__179Yo"};